module.exports = __webpack_public_path__ + "img/index-8.52ac6060.png";